module.exports = __webpack_public_path__ + "img/ArmadilloLogo_NavBar_Mobile.7f14e773.svg";